import {
  Avatar,
  Box,
  Button,
  Image,
  Container,
  Divider,
  Flex,
  Icon,
  Link,
  Text,
  VStack,
  Progress,
  Spinner,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { MdAutoAwesome, MdFileCopy, MdHome, MdLock } from 'react-icons/md';
import { PiChatCenteredDotsDuotone } from 'react-icons/pi';
import { GiNotebook } from 'react-icons/gi';
import { CgNotes } from 'react-icons/cg';
import { FiLogOut, FiSettings } from 'react-icons/fi';
import { useAuth } from '../../Context/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import vectorImage from '../../assets/Vector.svg';
import circleImage from '../../assets/circle.png';
import logoImage from '../../assets/Logo.png';
import StudywiseLogo from '../../assets/StudywiseLogo.svg';
import proImage from '../../assets/pro.png';
import { getAuthToken } from '../Helpers/script';
import axios from 'axios';
import { useSocket } from '../../Context/SocketContext';
import { FaChevronDown, FaCopy } from 'react-icons/fa';

const NavLink = ({ icon, text, path, onClose, activeAt }) => {
  const history = useHistory();
  const location = useLocation();

  const isActive = path => {
    if (path === '/')
      return (
        location?.pathname === path || activeAt?.includes(location?.pathname)
      );
    return (
      location?.pathname?.includes(path) ||
      activeAt?.includes(location?.pathname)
    );
  };

  return (
    <Box minWidth="150px" ml="-1rem">
      <Link
        height="18px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt="0.9rem"
        onClick={() => {
          history.push(path);
          if (onClose) onClose();
        }}
        _hover={{ textDecoration: 'none' }}
      >
        <Box me="12px" mt="6px">
          <Icon
            as={icon}
            width="1.4rem"
            height="1.4rem"
            color={isActive(path) ? '#603CFF' : '#C9CED4'}
          />
        </Box>

        <Text
          me="auto"
          fontWeight={isActive(path) ? '700' : '500'}
          letterSpacing="0px"
          // fontSize="sm"
          color={isActive(path) ? '#1B2559' : '#C9CED4'}
        >
          {text}
        </Text>
      </Link>
    </Box>
  );
};

const NavigationBar = ({ onClose }) => {
  const { currentUser, logout, setTopLevelError } = useAuth();
  const socket = useSocket();
  const history = useHistory();

  const [usage, setUsage] = useState(0);
  const [planLoading, setPlanLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      if (!currentUser) return;
      try {
        setPlanLoading(true);
        const token = await getAuthToken(currentUser);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL ?? ''}/api/getUserCredits`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Handle success response here if necessary

        if (response.status === 200) {
          const { creditsAvailable } = response.data;
          setUsage(creditsAvailable > 10 ? -1 : creditsAvailable);
        }
      } catch (err) {
        console.log(err);
        setTopLevelError(
          "Couldn't retrieve subscription details. Please try again later."
        );
      }
      setPlanLoading(false);
    };

    retrieve();
  }, [currentUser, setTopLevelError]);

  useEffect(() => {
    if (!socket) return;

    socket.on('retrieveCreditPoints', credits => {
      if (credits > 10) {
        setUsage(-1);
      } else {
        setUsage(credits);
      }
    });
    return () => {
      socket.off('retrieveCreditPoints');
    };
  }, [socket]);

  return (
    <Flex
      direction="column"
      height="95vh"
      minW="240px"
      mt="1vh"
      mb="1vh"
      borderRadius={`calc(15vw * 0.06)`}
      justifyContent="space-between"
      bg="#FFFFFF"
      boxShadow="0px 17px 40px 13px #7090B01C"
      color="#1B2559"
    >
      <Flex direction="column">
        <Flex
          height="80px"
          width="100%"
          justifyContent="center"
          ml="-0.8rem"
          direction="row"
          mt="32px"
        >
          {/* <Image
            height="5rem"
            width="5rem"
            src={vectorImage}
            alt="vector image"
          />
          <Box height="60px">
            <Image src={logoImage} alt="logo image" />
            <Image
              height="35px"
              width="140px"
              src={circleImage}
              alt="circle image"
            />
          </Box> */}
          <Box height="60px">
            <Image height="50px" src={StudywiseLogo} alt="Studywise Logo" />
          </Box>
        </Flex>
        <Flex direction="column" alignItems="center">
          <Divider pt="4px" />
          <VStack
            alignItems="center"
            mb="auto"
            mt="8px"
            p="0px 10px"
            pt="15px"
            w="100%"
            // pl="50px"
            fontSize="1rem"
            fontWeight="500"
          >
            <NavLink
              icon={MdAutoAwesome}
              text={'SMART Notes'}
              path="/"
              activeAt={['/smartNotes']}
              onClose={onClose}
            />
            {/* <Link
              height="18px"
              width="80%"
              display="flex"
              alignItems="center"
              onClick={() => history.push('/')}
            >
              <Box me="12px" mt="6px" color="#603CFF">
                <Icon
                  as={MdAutoAwesome}
                  width="17px"
                  height="17px"
                  color="inherit"
                />
              </Box>

              <Text
                me="auto"
                fontWeight="700"
                letterSpacing="0px"
                // fontSize="sm"
                color="#1B2559"
                fontFamily="Plus Jakarta Sans"
              >
                Study Chat
              </Text>
            </Link> */}

            {/* <NavLink
              icon={MdAutoAwesome}
              text="Study Notes"
              path="/smartNotes"
              onClose={onClose}
            /> */}

            <NavLink
              icon={PiChatCenteredDotsDuotone}
              text="Class Chatbot"
              path="/classChat"
              onClose={onClose}
            />
            <NavLink
              icon={GiNotebook}
              text="Homework Help"
              path="/homeworkHelp"
              onClose={onClose}
            />
            {/* <NavLink
              icon={GiNotebook}
              text="QuizCard"
              path="/QuizCard"
              onClose={onClose}
            /> */}
            <NavLink
              icon={FaCopy}
              text="Test Me Mode"
              path="/testMeMode"
              onClose={onClose}
              activeAt={['/configureQuiz', '/quizScoreCard', '/quiz']}
            />
            <NavLink
              icon={CgNotes}
              text="Saved Notes"
              path="/view/savedNotes"
              onClose={onClose}
            />
            <NavLink
              icon={CgNotes}
              text="Saved Quizzes"
              path="/view/savedQuizzes"
              onClose={onClose}
            />

            {/* <NavLink
              icon={MdFileCopy}
              text={'Test Me Mode'}
              path="/configureQuiz"
              onClose={onClose}
            /> */}
            {/* <NavLink
              icon={MdFileCopy}
              text={'Score Card [DEMO]'}
              path="/quizScoreCard"
              onClose={onClose}
            /> */}
          </VStack>
        </Flex>
      </Flex>

      <Flex direction="column">
        <Box
          direction="row"
          // minW="200px"
          width="90%"
          bg="linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)"
          mx="auto"
          justifyItems={'center'}
          alignItems={'center'}
          borderRadius={`calc(15vw * 0.06)`}
          textAlign="center"
          //justifyContent="space-around"
          pb="1rem"
        >
          <Image
            mt="-30px"
            mx="auto"
            height="80px"
            width="80px"
            src={proImage}
            alt="logo image"
          />

          {planLoading ? (
            <Spinner
              thickness="4px"
              speed="0.8s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          ) : (
            <>
              <Text
                mx="auto"
                mt="-20px"
                mb="0.7rem"
                fontWeight="700"
                letterSpacing="0px"
                fontSize="18px"
                color="#FFFFFF"
                width="fit-content"
              >
                {usage >= 0 ? 'Credits used today' : 'Studywise PRO'}
              </Text>
              {/* <Text
            mx="auto"
            fontWeight="500"
            letterSpacing="0px"
            fontSize="0.9rem"
            color="#FFFFFF"
          >
            Studywise PRO allows you to ask unlimited questions and receive
            access to all features.
          </Text> */}
              {usage >= 0 && (
                <>
                  <Flex justifyContent="center" m="0.7rem 0">
                    <Progress
                      colorScheme="whiteAlpha"
                      background="#7b5aff"
                      height="1.2rem"
                      min={0}
                      max={10}
                      value={10 - usage}
                      width="80%"
                      borderRadius="30px"
                    />
                  </Flex>
                  <Text
                    mx="auto"
                    fontWeight="500"
                    letterSpacing="0px"
                    fontSize="0.9rem"
                    color="#FFFFFF"
                  >
                    {10 - usage}/10 credits
                  </Text>
                </>
              )}

              <Button
                colorScheme="purple"
                variant="solid"
                size="xs"
                mt="10px"
                borderRadius="20px"
                padding="1rem"
                fontSize="0.9rem"
                fontWeight="500"
                letterSpacing="0.6px"
                onClick={() => {
                  history.push('/manage-subscription');
                  if (onClose) onClose();
                }}
              >
                {usage >= 0 ? 'Get unlimited with PRO' : 'Manage Subscription'}
              </Button>
            </>
          )}
        </Box>
        <Divider />
        <Flex
          mt="8px"
          justifyContent="space-evenly"
          alignItems="center"
          // boxShadow={shadowPillBar}
          borderRadius="30px"
          p="14px"
          color="#1B2559"
        >
          <Avatar
            h="34px"
            w="34px"
            name={
              currentUser?.displayName
                ? currentUser?.displayName
                : 'Studywise User'
            }
            title={
              currentUser?.displayName
                ? currentUser?.displayName
                : 'Studywise User'
            }
            src={currentUser?.photoURL ?? ''}
            referrerPolicy="no-referrer"
            me="10px"
            fontSize="16px"
          />
          <Text
            fontSize="0.9rem"
            fontWeight="600"
            me="10px"
            title={
              currentUser?.displayName
                ? currentUser?.displayName
                : 'Studywise User'
            }
          >
            {currentUser?.displayName
              ? currentUser?.displayName
              : 'Studywise User'}
          </Text>
          {/* <Button
            variant="transparent"
            border="1px solid"
            //   borderColor={border}
            borderRadius="full"
            w="34px"
            h="34px"
            px="0px"
            minW="34px"
            justifyContent={'center'}
            alignItems="center"
          >
            <Icon as={FiSettings} width="16px" height="16px" color="inherit" />
          </Button> */}
          <Button
            variant="transparent"
            border="1px solid"
            //   borderColor={border}
            borderRadius="full"
            w="34px"
            h="34px"
            px="0px"
            minW="34px"
            justifyContent={'center'}
            alignItems="center"
            onClick={logout}
          >
            <Icon as={FiLogOut} width="16px" height="16px" color="inherit" />
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NavigationBar;
